import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const uber = defineConnector({
  identifier: "uber",
  name: "Uber",
  tagLine: "Ride-hailing and delivery",
  logo,
  protocol: "http",
  tags: ["productivity", "travel"],
  defaultUrlPattern: () => "https://api\\.uber\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Uber app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Uber Developer Dashboard](https://developer.uber.com/dashboard) and create a new app. Select the APIs you need access to and note your client ID and secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/uber/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Uber account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Uber account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://auth.uber.com/oauth/v2/authorize",
    tokenEndpoint: () => "https://auth.uber.com/oauth/v2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.uber.com/v1.2/me",
  },
});
